import React, { useEffect, useRef, useState } from "react";
import {
  LuLibrary,
  LuChevronLeft,
  LuChevronRight,
  LuMoreHorizontal,
  LuPenLine,
  LuSearch,
  LuUploadCloud,
  LuX,
  LuComputer,
} from "react-icons/lu";
import Autocomplete from "@mui/material/Autocomplete";
import { createFilterOptions } from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { FaChevronDown, FaCloudDownloadAlt } from "react-icons/fa";
import { CSVLink } from "react-csv";
import CSVReader from "react-csv-reader";
import { OptionProps, ParamInterface } from "../../../interface-and-types";
import {
  userFormSchema,
  userFormType,
} from "../../../interface-and-types/user.schema";
import { UserInterface } from "../../../interface-and-types/users.interface";
import Preloader from "../../../app-components/preloader/Preloader";
import apiClient from "../../../api-services/ApiClient";
import { confirmAlert } from "../../../helpers/SweetAlert";
import { FaPlus, FaTrash } from "react-icons/fa6";
import { truncateText } from "../../../helpers";
import { ToastContainer, toast } from "react-toastify";
import Select from "react-select";
import { ExcelFile, ExcelSheet, ExcelColumn } from "react-xlsx-wrapper";
import { RiFileExcel2Line } from "react-icons/ri";
import { Link } from "react-router-dom";
import { SITELINKS } from "../../../app-routes/links";

const filterOptions = createFilterOptions({ limit: 100 });
const getOptionLabel = (option: any) => (
  <div
    dangerouslySetInnerHTML={{ __html: !!option.label ? option?.label : "" }}
  />
);
const CustomOption = (props: any) => (
  <div className="custom-option items-center flex py-2 border-b border-gray-100 hover:bg-blue-100">
    <input
      id={`id_${props.id}`}
      name={`id_${props.id}`}
      type="checkbox"
      checked={props.isSelected}
      onChange={() => {
        props.selectOption(props.data);
      }}
      className="mr-2 ml-2 mt-1"
      style={{ height: "14px", width: "14px" }}
    />
    <label
      className="mt-1 text-sm font-normal"
      onClick={() => {
        props.selectOption(props.data);
      }}
    >
      {props.label}
    </label>
  </div>
);

const VendorManagement = () => {
  const fileInputRef = useRef<any>(null);
  const [usersData, setUsersData] = useState<any[]>([]);
  const [usersExport, setUsersExport] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [searchInput, setSearchInput] = useState<string>("");
  const [searchInputDebounce, setSearchInputDebounce] = useState<string>("");
  const [isActiveStatus, setIsActiveStatus] = useState<string>("");
  const [roleName, setRoleName] = useState<string>("VesselOperator");
  const [companyName, setCompanyName] = useState<string>("");
  const [vendors, setVendors] = useState<OptionProps[]>([]);
  const [cmdbUsers, setCMDBUser] = useState<OptionProps[]>([]);
  const [roles, setRoles] = useState<OptionProps[]>([]);
  const [vessels, setVeseels] = useState<OptionProps[]>([]);
  const [vesselsData, setVeseelsData] = useState<any[]>([]);
  const [vesselCategories, setVeseelCategories] = useState<OptionProps[]>([]);
  const [functionalEmail, setFunctionalEmail] = useState<OptionProps[]>([]);
  const [userID, setUserID] = useState<string>("");

  const [serverError, setServerError] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [isCreateModalOpen, setCreateModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);

  const [formData, setFormData] = useState<userFormType>({
    firstName: "",
    lastName: "",
    companyId: "",
    role: "",
    phone: "",
    officialEmail: "",
    personalEmail: "",
    vessel: "",
    vesselCategory: "",
    functionalEmail: "",
    personalPhone: "",
  });

  const [errors, setErrors] = useState<
    Partial<Record<keyof userFormType, string>>
  >({});

  const csvTemplate = [
    [
      "company",
      "email",
      "firstname",
      "lastname",
      "phone",
      "RoleNames",
      "vessels",
      "personalemail",
      "personalPhone",
    ],
    [
      "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      "adetayo.taiwo@external.totalenergies.com",
      "Adetayo",
      "TAIWO",
      "2348102031540",
      "MarineSuperintendent,  Administrator",
      "3fa85f64-5717-4562-b3fc-2c963f66afa6, 3fa85f64-1017-4562-b3fc-2c963f66afa6",
      "adetayo.taiwo@external.totalenergies.com",
      "2348102031540",
    ],
  ];

  // effect for get users list
  useEffect(() => {
    const isActive =
      {
        active: true,
        not_active: false,
      }[isActiveStatus] ?? null;

    const params = {
      page: currentPage,
      IsActive: isActive,
      SearchString: searchInput,
      RoleName: roleName,
      OrderBy: "Descending",
      PageSize: pageSize,
      CompanyName: companyName,
    };

    getUsers(params);
  }, [
    currentPage,
    searchInput,
    isActiveStatus,
    roleName,
    companyName,
    pageSize,
  ]);

  useEffect(() => {
    getCompany();
    getCMDBUser();
    getRoles();
    getVessels();
    geFunctionalEmail();
  }, []);

  // debounce search input
  useEffect(() => {
    const handler = setTimeout(() => {
      setSearchInput(searchInputDebounce);
      setCurrentPage(1);
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [searchInputDebounce]);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleRoleChange = (item: any) => {
    setServerError("");
    const hasVessel = item.find(
      (el: any) => el?.label === "VesselOperator"
    )?.name;

    if (item.length > 1 && hasVessel) {
      setServerError("Vessel operator and other role cannot coexist!");
      return;
    }

    const str = JSON.stringify(item);
    setFormData({ ...formData, role: str });
  };

  const handleVesselChange = (item: any) => {
    const str = JSON.stringify(item);
    setFormData({ ...formData, vessel: str });
  };

  const handleVesselCategoryChange = (item: any) => {
    console.log(item);

    const id = item.value;
    const filteredVessel = vesselsData
      .filter((item) => item.vesselCategory?.id === id)
      .map((item) => ({
        label: item.name,
        value: item.id,
        name: "vesselCategory",
        key: item.id,
      }));

    setVeseels(filteredVessel);
    setFormData({ ...formData, vesselCategory: JSON.stringify(item) });
  };

  const handleFunctionalEmailChange = (item: any) => {
    const str = JSON.stringify(item);
    setFormData({ ...formData, functionalEmail: str });
  };

  const handleCompanyName = (el: any, option: any) => {
    setCompanyName(option?.value ?? "");
  };

  const handleCompanyId = (el: any, option: any) => {
    setFormData({
      ...formData,
      companyId: option?.value ?? "",
      personalEmail: option?.email,
      officialEmail: option?.email,
      phone: option?.phone,
    });
  };

  const handleCMDBUser = (el: any, option: any) => {
    const cmdb_users: any = cmdbUsers.find(
      (item) => item.value === option?.value
    );
    setFormData({
      ...formData,
      officialEmail: option?.value ?? "",
      firstName: cmdb_users?.firstName ?? "",
      lastName: cmdb_users?.lastName ?? "",
    });
  };

  const handleUpdateUserInput = (user: any) => {
    setUserID(user.id);

    const selectedRoles = user.userRoles.filter(
      (item: any) => item.role.name !== "User"
    );

    const userRole = selectedRoles.map((i: any) => ({
      label: i.role.description,
      value: i.role.name,
      id: i.role.name,
      name: "Roles",
      key: i.role.name,
    }));

    const userVessels = user?.userVessels.map((i: any) => ({
      label: i.vessel.description,
      value: i.vessel.id,
      id: i.vessel.id,
      name: "vessel",
      key: i.vessel.id,
    }));

    const functionalEmails = user?.userFunctionalEmails.map((i: any) => ({
      label: i.functionalEmail.email,
      value: i.functionalEmail.email,
      id: i.functionalEmail.email,
      name: "functionalEmail",
      key: i.functionalEmail.id,
    }));


    const totalPersonelEmail = userRole[0].label.includes('VesselOperator') ? user.personalEmail : user.email;

    setFormData({
      firstName: user.firstName,
      lastName: user.lastName,
      companyId: user.company.name,
      role: JSON.stringify(userRole),
      phone: user.phoneNumber || "",
      officialEmail: totalPersonelEmail,
      personalEmail: user.email || "",
      personalPhone: user.personalPhoneNumber || "",
      vessel: JSON.stringify(userVessels),
      functionalEmail: JSON.stringify(functionalEmails),
    });
  };

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Trigger the file input click
    }
  };

  const handleStatusUpdate = async (
    id: string | number,
    isEnabled: boolean
  ) => {
    try {
      // Create a copy of the current users data for rollback in case of failure
      const previousUsersData = [...usersData];

      // Optimistically update the UI
      const updatedUsersData = usersData.map((user: any) =>
        user.id === id ? { ...user, isEnabled } : user
      );
      setUsersData(updatedUsersData);

      // Make the API call
      const res = await apiClient.patch(
        `Users/${isEnabled ? "Enable" : "Disable"}?UserId=${id}`
      );

      // Check if the response is successful
      if (res.data.status) {
        console.log(res);
      } else {
        setUsersData(previousUsersData);
      }
    } catch (error) {
      console.error("Error while updating status:", error);
    }
  };

  const getUsers = async (params: ParamInterface) => {
    setLoading(true);
    try {
      const res: any = await apiClient.get("Users", { params });
      if (res && res.data) {
        setUsersData(res.data.data);
        setCurrentPage(res.data.pageIndex);
        setLastPage(res.data.totalPages);

        const processedData = res.data.data.map((item: any) => ({
          userId: item.userId,
          firstName: item.firstName,
          lastName: item.lastName,
          email: item.email,
          phoneNumber: item.phoneNumber,
          personalEmail: item.personalEmail,
          isEnabled: item.isEnabled ? "Yes" : "No",
          isFirstLogin: item.isFirstLogin ? "Yes" : "No",
          isPasswordChanged: item.isPasswordChanged ? "Yes" : "No",
          companyName: item.companyName,
          companyCode: item.companyCode,
          companyEmail: item.companyEmail,
          companyPhone: item.companyPhone,
          companyAddress: item.companyAddress,
          companyCity: item.companyCity,
          companyTinNo: item.companyTinNo,
          roleName: item.roleName,
          roleDescription: item.roleDescription,
          vesselName: item.vesselName,
          vesselType: item.vesselType,
          vesselAffiliate: item.vesselAffiliate,
          mmsi: item.mmsi,
        }));

        setUsersExport(processedData);
      } else {
        setUsersData([]);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      setUsersData([]);
    } finally {
      setLoading(false);
    }
  };

  const getCompany = async () => {
    try {
      const params = {
        PageSize: 10000,
      };
      const res: any = await apiClient.get("Company", { params });
      if (res && res.data) {
        const options: OptionProps[] = res.data.data.map(
          (i: any, index: number) => ({
            label: `<div><span style="display:none">${index}</span> ${i.name}</div><div style="position:relative; top:-5px"><small>${i.address} ${i.city}</small></div>`,
            value: i.name,
            id: i.id,
            name: "tepng_users",
            key: index,
            email: i?.email,
            phone: i?.phone,
          })
        );

        setVendors(options);
      }
    } catch (error) {
      console.error("Error fetching vendors:", error);
    }
  };

  const getCMDBUser = async () => {
    try {
      const params = {
        PageSize: 30000,
      };

      const res: any = await apiClient.get("Users/CMDBUsers", { params });
      if (res && res.data) {
        const options: OptionProps[] = res.data.data.map(
          (i: any, index: number) => ({
            label: `<div><span style="display:none">${index}</span> ${i.email}</div><div style="position:relative; top:-5px"><small>${i.firstName} ${i.lastName}  (${i.userId})</small></div>`,
            value: i.email,
            name: "CMDBUsers",
            firstName: i.firstName,
            lastName: i.lastName,
            key: index,
          })
        );
        setCMDBUser(options);
      }
    } catch (error) {
      console.error("Error fetching vendors:", error);
    }
  };

  const getRoles = async () => {
    try {
      const res: any = await apiClient.get("Roles");
      if (res && res.data) {
        const options: OptionProps[] = res.data.data.map(
          (i: any, index: number) => ({
            label: i.description,
            value: i.name,
            id: i.name,
            name: "Roles",
            key: index,
          })
        );

        setRoles(options);
      }
    } catch (error) {
      console.error("Error fetching vendors:", error);
    }
  };

  const getVessels = async () => {
    try {
      const res: any = await apiClient.get("Vessels?PageSize=10000");
      if (res && res.data) {
        const options: OptionProps[] = res.data.data.map(
          (i: any, index: number) => ({
            label: i.name,
            value: i.id,
            name: "Vessels",
            key: index,
          })
        );

        const optionCategories: OptionProps[] = res.data.data.map(
          (i: any, index: number) => ({
            label: i.vesselCategory?.name,
            value: i.vesselCategory?.id,
            name: "vesselCategory",
            key: i.vesselCategory?.id,
          })
        );

        const uniqueByName = [
          ...new Map(
            optionCategories.map((item: any) => [item.label, item])
          ).values(),
        ];

        setVeseelsData(res.data.data);
        setVeseels(options);
        setVeseelCategories(uniqueByName);
      }
    } catch (error) {
      console.error("Error fetching vendors:", error);
    }
  };

  const geFunctionalEmail = async () => {
    try {
      const res: any = await apiClient.get("FunctionalEmail");
      if (res && res.data) {
        const options: OptionProps[] = res.data.data.map(
          (i: any, index: number) => ({
            label: i.email,
            value: i.email,
            name: "FunctionalEmail",
            key: index,
          })
        );
        setFunctionalEmail(options);
      }
    } catch (error) {
      console.error("Error fetching vendors:", error);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < lastPage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleCreateSubmit = async (e: any) => {
    e.preventDefault();
    setErrors({});
    setServerError("");

    const result = userFormSchema.safeParse(formData);

    if (result.success) {
      setLoading(true);

      try {
        const formControl = result.data;

        let selectedCompany =
          formControl.companyId === ""
            ? "TOTALENERGIES EP NG"
            : formControl.companyId;
        const companyId = vendors.find(
          (item) => item.value === selectedCompany
        );

        const roleArr = JSON.parse(formControl.role);
        const functionalEmailArr = !!formControl.functionalEmail
          ? JSON.parse(formControl.functionalEmail)
          : [];
        const vesselArr = !!formControl.vessel
          ? JSON.parse(formControl.vessel)
          : [];

        const selectedRole = roleArr.map((item: any) => item.label);
        const selectedVessel = vesselArr.map((item: any) => item.value);
        const functionalEmail = functionalEmailArr.map(
          (item: any) => item.value
        );


        const totalPersonelEmail = selectedRole.includes('VesselOperator') ? formControl.personalEmail : formControl.officialEmail

        const data: any = {
          lastName: formControl.lastName,
          firstName: formControl.firstName,
          email: totalPersonelEmail, //formControl.personalEmail || null,
          phoneNumber: formControl?.phone?.replace(/\s+/g, "") || null,
          personalPhoneNumber: formControl?.personalPhone?.replace(/\s+/g, "") || null,
          personalEmail: formControl.officialEmail,
          companyId: companyId?.id,
          roleNames: selectedRole,
          vesselIds: selectedVessel,
          functionalEmails: functionalEmail,
        };

        await apiClient.post("Users", data);

        const params = {
          page: currentPage,
          SearchString: searchInput,
          RoleName: roleName,
          OrderBy: "Descending",
          PageSize: 10,
          CompanyName: companyName,
        };

        await getUsers(params);

        toast.success("User created successfully!", {
          autoClose: 60000,
          theme: "colored", // Options: "light", "dark", "colored"
        });

        setFormData({
          firstName: "",
          lastName: "",
          companyId: "",
          role: "",
          phone: "",
          officialEmail: "",
          personalEmail: "",
          vessel: "",
        });

        setCreateModalOpen(false);
      } catch (error: any) {
        setServerError(JSON.stringify(error));
      } finally {
        setLoading(false);
      }
    } else {

      const formattedErrors: Partial<Record<keyof userFormType, string>> = {};

      result.error.errors.forEach((err: any) => {
        if (err.path.length > 0) {
          const key = err.path[0] as keyof userFormType;
          formattedErrors[key] = err.message;
        }
      });

      console.log(formattedErrors);

      setErrors(formattedErrors);
      setServerError("Validation error");
    }
  };

  const handleEditSubmit = async (e: any) => {
    e.preventDefault();
    setErrors({});
    setServerError("");

    const id = userID;
    const result = userFormSchema.safeParse(formData);

    if (result.success) {
      setLoading(true);
      try {
        const formControl = result.data;

        let selectedCompany =
          formControl.companyId === ""
            ? "TOTALENERGIES EP NG"
            : formControl.companyId;
        const companyId = vendors.find(
          (item) => item.value === selectedCompany
        );

        const roleArr = JSON.parse(formControl.role);
        const functionalEmailArr = !!formControl.functionalEmail
          ? JSON.parse(formControl.functionalEmail)
          : [];
        const vesselArr = !!formControl.vessel
          ? JSON.parse(formControl.vessel)
          : [];

        const selectedRole = roleArr.map((item: any) => item.label);
        const selectedVessel = vesselArr.map((item: any) => item.value);
        const functionalEmail = functionalEmailArr.map(
          (item: any) => item.value
        );


        const totalPersonelEmail = selectedRole.includes('VesselOperator') ? formControl.personalEmail : formControl.officialEmail;
        const data: any = {
          lastName: formControl.lastName,
          firstName: formControl.firstName,
          email: totalPersonelEmail,
          phoneNumber: formControl?.phone?.replace(/\s+/g, "") || null,
          personalPhoneNumber:
            formControl?.personalPhone?.replace(/\s+/g, "") || null,
          personalEmail: formControl.officialEmail || null,
          companyId: companyId?.id,
          roleNames: selectedRole,
          vesselIds: selectedVessel,
          functionalEmails: functionalEmail,
        };

        const res = await apiClient.patch(`Users/${id}`, data);
        console.log(res);

        const params = {
          page: currentPage,
          SearchString: searchInput,
          RoleName: roleName,
          OrderBy: "Descending",
          PageSize: 10,
          CompanyName: companyName,
        };

        await getUsers(params);
        toast.success("User updated successfully!", {
          autoClose: 60000,
          theme: "colored",
        });

        setFormData({
          firstName: "",
          lastName: "",
          companyId: "",
          role: "",
          phone: "",
          officialEmail: "",
          personalEmail: "",
          vessel: "",
        });

        setEditModalOpen(false);
      } catch (error: any) {
        setServerError(JSON.stringify(error));
      } finally {
        setLoading(false);
      }
    } else {
      const formattedErrors: Partial<Record<keyof userFormType, string>> = {};

      result.error.errors.forEach((err: any) => {
        if (err.path.length > 0) {
          const key = err.path[0] as keyof userFormType;
          formattedErrors[key] = err.message;
        }
      });

      setServerError("Validation error");
      setErrors(formattedErrors);

      console.log(formattedErrors);
    }
  };

  const handleFileLoaded = async (data: any) => {
    const createBulkUsers = data.map((user: any) => ({
      lastName: user.lastname || "", // Default to empty string if undefined
      firstName: user.firstname || "",
      email: user.email || "",
      phoneNumber: user.phone || "",
      personalEmail: user.personalemail || "",
      companyId: user.company || "", // Ensure you have a valid UUID or default value
      roleNames: user.roles
        ? user.roles.split(",").map((name: any) => name.trim())
        : [], // Default to an empty array if undefined
      vesselIds: user.vessels
        ? user.vessels.split(",").map((id: any) => id.trim())
        : [],
    }));

    const bulkdata: any = {
      createBulkUsers: createBulkUsers,
    };

    const result = await confirmAlert(
      "Do you want to upload bulk user accunt?"
    );

    if (result.isConfirmed) {
      setLoading(true);
    } else {
      // Clear the file input after processing
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Clear the input value
      }
      return;
    }

    try {
      const res = await apiClient.post("Users/BulkCreate", bulkdata);
      console.log(res);

      const params = {
        page: currentPage,
        SearchString: searchInput,
        RoleName: roleName,
        OrderBy: "Descending",
        PageSize: 10,
        CompanyName: companyName,
      };

      await getUsers(params);
      toast.success("successful!", {
        autoClose: 60000,
        theme: "colored", // Options: "light", "dark", "colored"
      });
    } catch {
      toast.error("error occured!", {
        autoClose: 60000,
        theme: "colored", // Options: "light", "dark", "colored"
      });
    } finally {
      setLoading(false);
    }

    // Clear the file input after processing
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Clear the input value
    }
  };

  const isVesselOperator = () => {
    if (!formData.role) {
      return;
    }

    const arr = JSON.parse(formData.role ? formData.role : "");

    if (!!arr.length) {
      const hasVesselOperator = arr.find(
        (el: any) => el.label === "VesselOperator"
      )?.name;

      if (hasVesselOperator) {
        return true;
      }
    }
    return false;
  };

  const emptyInput = () => {
    setFormData({
      firstName: "",
      lastName: "",
      companyId: "",
      role: "",
      phone: "",
      officialEmail: "",
      personalEmail: "",
      vessel: "",
    });

    setServerError("");
  };

  const handleRemoveRole = async (userId: string, roleId: string) => {
    console.log(userId);
    const canRemove = await confirmAlert("Do you want to remove role?");
    if (canRemove.isConfirmed) {
      try {
        setLoading(true);

        const data = {
          roleIds: [roleId],
        };

        await apiClient.delete(`UserRoles/${userId}`, {
          data: data,
        });

        const params = {
          page: currentPage,
          SearchString: searchInput,
          RoleName: roleName,
          OrderBy: "Descending",
          PageSize: 10,
          CompanyName: companyName,
        };
        await getUsers(params);
        toast.success("updated successfully!", {
          autoClose: 60000,
          theme: "colored",
        });
      } catch (error: any) {
        toast.error(JSON.stringify(error));
      } finally {
        setLoading(false);
      }
    }
  };

  const handleReinvite = async (email: string) => {
    const canInvite = await confirmAlert("Do you want to re-invite user");
    if (canInvite.isConfirmed) {
      try {
        setLoading(true);

        const data = {
          email: email,
        };

        await apiClient.post(`AzureUser/ResetGuestUserInvite`, {
          data: data,
        });

        toast.success("Invite sent successfully!", {
          autoClose: 60000,
          theme: "colored",
        });
      } catch (error: any) {
        toast.error(JSON.stringify(error));
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      <section className="flex justify-between items-center bg-gradient-to-r from-secondaryBlue to-primaryBlue shadow-md border-b border-gray-200">
        <div className="xl:container xl:mx-auto md:px-4 py-4 pb-24 flex justify-between items-center">
          <h4 className="lg:text-[20px] text-white nunito font-medium">
            Manage Users
          </h4>

          {/*page actions */}
          <div className="flex gap-2">
            <ExcelFile
              filename={"User-Data"}
              element={
                <button className="border-white border-2 flex gap-2 p-1 px-3 rounded-md text-sm items-center text-white hover:shadow-xl shadow h-full">
                  <RiFileExcel2Line />
                  <span>Export User Data</span>
                </button>
              }
            >
              <ExcelSheet data={usersExport} name="User Data">
                <ExcelColumn label="User ID" value="userId" />
                <ExcelColumn label="First Name" value="firstName" />
                <ExcelColumn label="Last Name" value="lastName" />
                <ExcelColumn label="Email" value="email" />
                <ExcelColumn label="Phone Number" value="phoneNumber" />
                <ExcelColumn label="Personal Email" value="personalEmail" />
                <ExcelColumn label="Is Enabled" value="isEnabled" />
                <ExcelColumn label="Is First Login" value="isFirstLogin" />
                <ExcelColumn
                  label="Is Password Changed"
                  value="isPasswordChanged"
                />
                <ExcelColumn label="Company Name" value="companyName" />
                <ExcelColumn label="Company Code" value="companyCode" />
                <ExcelColumn label="Company Email" value="companyEmail" />
                <ExcelColumn label="Company Phone" value="companyPhone" />
                <ExcelColumn label="Company Address" value="companyAddress" />
                <ExcelColumn label="Company City" value="companyCity" />
                <ExcelColumn label="Company Tin No" value="companyTinNo" />
                <ExcelColumn label="Role Name" value="roleName" />
                <ExcelColumn label="Role Description" value="roleDescription" />
                <ExcelColumn label="Vessel Name" value="vesselName" />
                <ExcelColumn label="Vessel Type" value="vesselType" />
                <ExcelColumn label="Vessel Affiliate" value="vesselAffiliate" />
                <ExcelColumn label="MMSI" value="mmsi" />
              </ExcelSheet>
            </ExcelFile>

            <CSVLink
              data={csvTemplate}
              className="flex gap-2 items-center text-sm bg-green-500 hover:bg-green-700 shadow hover:shadow-3xl p-2 rounded-md text-white px-3 transition-colors duration-300 ease-in-out transform h-full"
            >
              <FaCloudDownloadAlt />
              <span>Bulk Template</span>
            </CSVLink>

            <div>
              {/* Hidden file input */}
              <div style={{ display: "none" }}>
                <CSVReader
                  ref={fileInputRef}
                  onFileLoaded={handleFileLoaded}
                  parserOptions={{ header: true }}
                />
              </div>

              {/* Custom button */}
              <button
                className="flex gap-2 items-center text-sm bg-blue-600 hover:bg-blue-800 shadow p-2 rounded-md text-white  px-3 transition-colors duration-300 ease-in-out transform h-full"
                onClick={handleButtonClick}
              >
                <LuUploadCloud />
                <span>Bulk Upload</span>
              </button>
            </div>

            <button
              className="flex gap-1 items-center text-sm bg-red-500  hover:bg-red-700 shadow py-2 rounded-md text-white px-3 transition-colors duration-300 ease-in-out transform"
              onClick={() => {
                setCreateModalOpen(true);
                emptyInput();
              }}
            >
              <FaPlus />
              <span>Add User</span>
            </button>
          </div>
        </div>
      </section>

      {/* page content */}
      <section className="pt-5 mx-auto md:px-4 xl:container relative top-[-100px] xl:top-[-90px]">
        <div className="rounded-lg pb-6 bg-white shadow-sm">
          <div>
            <ul
              className="flex border-b border-gray-200 text-[14px] font-medium gap-10"
              role="tablist"
            >
              <li className="mr-2" role="presentation">
                <Link
                  to={SITELINKS.USERS}
                  className="inline-block p-6 border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 rounded-t-lg"
                  role="tab"
                  aria-selected="false"
                >
                  ALL Users
                </Link>
              </li>

              <li className="mr-2" role="presentation">
                <Link
                  to={SITELINKS.VENDORS}
                  className="inline-block p-6 border-b-2 border-blue-700 text-blue-700 rounded-t-lg"
                  role="tab"
                  aria-selected="true"
                >
                  Vessel Operators
                </Link>
              </li>
            </ul>
          </div>


          {/* page filter && search */}
          <div className="p-4 2xl:p-6 flex justify-between">
            <div className="relative xl:w-1/3 w-1/2">
              <input
                value={searchInputDebounce}
                onChange={(e) => setSearchInputDebounce(e.target.value)}
                placeholder="Search user"
                className="p-2 text-xs border border-gray-300 hover:border-blue-400 rounded-lg w-full"
              />
              <LuSearch className="text-lg top-[7px] absolute right-[9px] text-gray-400" />
            </div>

            <div className="flex gap-2">
              <Autocomplete
                className="mu-input p-2 pb-1 items-center flex pb-0 text-xs border border-gray-300 hover:border-blue-400 rounded-lg w-[200px]"
                filterOptions={filterOptions}
                disableClearable={false}
                onChange={(e, v) => handleCompanyName(e, v)}
                id="companyName"
                options={vendors}
                value={companyName}
                renderInput={(params) => (
                  <TextField
                    placeholder="Filter by company"
                    variant="standard"
                    {...params}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <InputAdornment position="end">
                          <FaChevronDown className="text-black font-[900] text-end text-[10px]" />{" "}
                          {/* Custom icon */}
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                renderOption={(props, option) => (
                  <li
                    {...props}
                    style={{
                      fontFamily: "Poppins",
                      fontSize: "12px",
                      fontWeight: "400",
                    }}
                  >
                    {getOptionLabel(option)}
                  </li>
                )}
              />

              <select
                value={pageSize}
                onChange={(e) => setPageSize(Number(e.target.value))}
                id="entries"
                className="p-2 py-1.5 text-xs border border-gray-300 hover:border-blue-400 rounded-lg"
              >
                <option value="10">Show 10 entries</option>
                <option value="25">Show 25 entries</option>
                <option value="50">Show 50 entries</option>
                <option value="100">Show 100 entries</option>
                <option value="250">Show 250 entries</option>
                <option value="500">Show 500 entries</option>
                <option value="1000">Show 1000 entries</option>
              </select>

              <select
                className="p-2 text-xs border border-gray-300 hover:border-blue-400 rounded-lg hidden"
                onChange={(e) => {
                  setRoleName(e.target.value);
                  setCurrentPage(1);
                }}
                value={roleName}
              >
                <option value="" disabled>
                  Filter by role
                </option>
                <option value="">All</option>
                {roles.map((item) => {
                  return (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  );
                })}
              </select>

              <select
                className="p-2 text-xs border border-gray-300 hover:border-blue-400 rounded-lg"
                onChange={(e) => {
                  setIsActiveStatus(e.target.value);
                  setCurrentPage(1);
                }}
                value={isActiveStatus}
              >
                <option value="" disabled>
                  Filter by status
                </option>
                <option value="">All</option>
                <option value="active">Active</option>
                <option value="not_active">Not active</option>
              </select>
            </div>
          </div>

          <div className="overflow-x-auto mb-5 overflow-y-auto">
            <table className="min-w-full bg-white mb-4">
              <thead>
                <tr className="w-full bg-slate-100 text-slate-600 capitalize text-[12px] leading-normal border-b shadow-sm">
                  {/* <th className="py-3 px-3 text-left font-medium">Firstname</th>
                  <th className="py-3 px-3 text-left font-medium">Lastname</th> */}
                  <th className="py-3 px-3 text-left font-medium">Email</th>
                  <th className="py-3 px-3 text-left font-medium">Phone</th>
                  <th className="py-3 px-3 text-left font-medium">Company</th>
                  <th className="py-3 px-3 text-left font-medium">Role</th>
                  <th className="py-3 px-3 text-left font-medium">Status</th>
                  <th className="py-3 px-3 text-center font-medium">Actions</th>
                </tr>
              </thead>

              {!!usersData?.length && (
                <tbody>
                  {usersData?.map((user: UserInterface, i: number) => {
                    return (
                      <tr
                        key={user.id}
                        className={`border-b border-[#F2F1F1] hover:bg-gray-100 font-normal text-xs ${!user.isEnabled ? "text-slate-400" : "text-slate-600"
                          }`}
                      >
                        {/* <td className="py-3 px-3 text-left align-top">
                          {user.firstName ?? ""}
                        </td>

                        <td className="py-3 px-3 text-left align-top">
                          {user.lastName ?? ""}
                        </td> */}

                        <td
                          className="py-3 px-3 text-left break-words max-w-[250px] align-top cursor-pointer"
                          title={user.email ?? ""}
                        >
                          {truncateText(user.email ?? "", 35)}
                        </td>

                        <td className="py-3 px-3 text-left align-top">
                          {user?.phoneNumber ?? ""}
                        </td>

                        <td className="py-3 px-3 text-left align-top">
                          {user.company.name ?? ""}
                        </td>

                        <td className="py-3 px-3 text-left align-top">
                          {user.userRoles
                            .filter((item: any) => item.role?.name !== "User")
                            .map((useritem: any) => (
                              <div
                                key={useritem.role?.id}
                                className="flex justify-between items-center gap-1 max-w-[165px]"
                              >
                                <p className="whitespace-nowrap">
                                  {useritem.role?.description}
                                </p>

                                <button className="hidden text-red-500 rounded-full text-[10px] p-0 m-0 flex justify-end items-center w-full">
                                  <FaTrash
                                    onClick={() =>
                                      handleRemoveRole(
                                        user?.id,
                                        useritem.role?.id
                                      )
                                    }
                                  />
                                </button>
                                <br />
                              </div>
                            ))}
                        </td>

                        <td className="py-3 px-3 text-left align-top">
                          {user.isEnabled ? "Activated" : "Deactivated"}
                        </td>

                        <td className="py-3 px-3 text-center flex gap-3 items-center align-top">
                          <div>
                            <button
                              className={`w-6 h-4 flex items-center bg-gray-300 rounded-full p-1 cursor-pointer ${user.isEnabled ? "bg-green-600" : "bg-gray-300"
                                }`}
                              onClick={() =>
                                handleStatusUpdate(user.id, !user.isEnabled)
                              }
                            >
                              <div
                                className={`bg-white w-2 h-2 rounded-full shadow-md transform duration-300 ease-in-out ${user.isEnabled
                                  ? "translate-x-2"
                                  : "translate-x-0"
                                  }`}
                              ></div>
                            </button>
                          </div>

                          <button
                            className={`font-medium flex gap-1 items-center ${!user.isEnabled ? "text-gray-400" : "text-red-600"
                              }`}
                            onClick={() => {
                              handleUpdateUserInput(user);
                              setEditModalOpen(true);
                            }}
                          >
                            <LuPenLine />
                            <span>Update</span>
                          </button>
                          {!user?.email.match("totalenergies") &&
                            user?.isFirstLogin && (
                              <button
                                className={`font-medium flex gap-1 items-center hidden ${!user.isEnabled
                                  ? "text-gray-400"
                                  : "text-green-800"
                                  }`}
                                onClick={() => {
                                  handleReinvite(user?.email);
                                }}
                              >
                                <LuComputer />
                                <span>Re-Invite</span>
                              </button>
                            )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              )}
            </table>

            {!usersData?.length && (
              <div className="text-center p-5 text-sm text-gray-500 ">
                <LuLibrary className="text-[50px] w-full" />
                <p> No record found</p>
              </div>
            )}
          </div>

          <div className="flex justify-center gap-3 flex-wrap">
            {/* Previous Button */}
            <button
              onClick={handlePrevious}
              disabled={currentPage === 1}
              className={`bg-[#fff] text-gray-500 text-xs p-1 px-2 rounded-lg border-2 border-solid border-[#F2F1F1] font-normal ${currentPage === 1
                ? "disabled:text-gray-400 disabled:cursor-not-allowed"
                : ""
                }`}
            >
              <span>Previous</span>
            </button>

            {/* Left Arrow */}
            <button
              disabled={currentPage === 1}
              onClick={handlePrevious}
              className={`bg-[#fff] text-gray-400 p-1 px-2 rounded-lg border-2 border-solid border-[#F2F1F1] text-base font-medium ${currentPage === 1
                ? "disabled:text-gray-400 disabled:cursor-not-allowed"
                : ""
                }`}
            >
              <LuChevronLeft className="text-xl" />
            </button>

            {/* Page Numbers */}
            {Array.from(
              { length: lastPage > 7 ? 3 : lastPage },
              (_, i) => i + 1
            ).map((page) => (
              <button
                title={`page ${page}`}
                key={page}
                onClick={() => setCurrentPage(page)}
                className={`p-1 px-3 rounded-lg border-2 border-solid border-[#F2F1F1] font-normal text-xs ${page === currentPage
                  ? "bg-red-600 text-white"
                  : "bg-[#fff] text-gray-600"
                  }`}
              >
                <span>{page}</span>
              </button>
            ))}

            {lastPage > 7 && (
              <>
                {/* ellipse Arrow */}
                <button
                  disabled
                  className={`bg-[#fff] text-gray-600 p-1 px-2 rounded-lg border-2 border-solid border-[#F2F1F1]`}
                >
                  <LuMoreHorizontal className="text-xl" />
                </button>

                {/* Page Numbers */}
                {Array.from({ length: 3 }, (_, i) => 2 - i).map((page) => (
                  <button
                    title={`page ${lastPage - page}`}
                    key={lastPage - page}
                    onClick={() => setCurrentPage(lastPage - page)}
                    className={`p-1 px-3 rounded-lg border-2 border-solid border-[#F2F1F1] text-base font-normal text-xs ${lastPage - page === currentPage
                      ? "bg-red-600 text-white"
                      : "bg-[#fff] text-gray-600"
                      }`}
                  >
                    <span>{lastPage - page}</span>
                  </button>
                ))}
              </>
            )}

            {/* Right Arrow */}
            <button
              disabled={currentPage === lastPage}
              onClick={handleNext}
              className={`bg-[#fff] text-gray-400 p-1 px-2 rounded-lg border-2 border-solid border-[#F2F1F1] ${currentPage === lastPage
                ? "disabled:text-gray-400 disabled:cursor-not-allowed"
                : ""
                }`}
            >
              <LuChevronRight className="text-xl" />
            </button>

            {/* Next Button */}
            <button
              onClick={handleNext}
              disabled={currentPage === lastPage}
              className={`bg-[#fff] text-gray-500 text-xs p-1 px-2 rounded-lg border-2 border-solid border-[#F2F1F1] font-normal ${currentPage === lastPage
                ? "disabled:text-gray-400 disabled:cursor-not-allowed"
                : ""
                }`}
            >
              <span>Next</span>
            </button>
          </div>
        </div>
      </section>

      {/* create user */}
      {isCreateModalOpen && (
        <section className="fixed inset-0 bg-black bg-opacity-50 flex flex-col justify-center items-center">
          <button
            onClick={() => setCreateModalOpen(false)}
            className="mt-4 text-red-600 hover:underline p-3 rounded-full bg-white mb-4 text-xl border border-gray-500 shadow animate-modalShow"
          >
            <LuX />
          </button>

          <div className="bg-white rounded shadow-md w-full max-w-xl animate-modalShow">
            <form onSubmit={handleCreateSubmit} autoComplete="off">
              <h2 className="text-sm font-medium mb-4 flex-col border-b p-3 px-6 bg-gray-100 rounded-t">
                Add new user
              </h2>

              <div className="grid grid-cols-1 gap-3 gap-y-3 sm:grid-cols-2 w-full  px-6 pb-16 max-h-[90vh] overflow-y-scroll mb-4">
                <div className="col-span-1">
                  <label className="block text-gray-700 text-xs" htmlFor="role">
                    Select Role
                  </label>

                  <Select
                    isMulti
                    options={roles}
                    value={!!formData.role ? JSON.parse(formData.role) : []}
                    onChange={handleRoleChange}
                    placeholder="Select options..."
                    className="mt-1"
                    components={{
                      Option: CustomOption,
                    }}
                  />

                  <span className="text-red-600 text-[10px]">
                    {errors.role}
                  </span>
                </div>

                {!isVesselOperator() && (
                  <div className="col-span-1">
                    <label
                      className="block text-gray-700 text-xs"
                      htmlFor="officialEmail"
                    >
                      {isVesselOperator() ? "Personal Email" : "Official Email"}
                    </label>

                    {isVesselOperator() ? (
                      <input
                        type="email"
                        name="officialEmail"
                        value={formData.officialEmail}
                        onChange={handleChange}
                        className="mt-1 p-2 border border-gray-300 rounded w-full text-sm  animate-modalShow"
                      />
                    ) : (
                      <Autocomplete
                        className="mu-input mt-1 p-2 border border-gray-300 rounded w-full text-sm animate-modalShow"
                        filterOptions={filterOptions}
                        disableClearable={false}
                        onChange={(e, v) => handleCMDBUser(e, v)}
                        id="cmdbUsers"
                        options={cmdbUsers}
                        value={formData.officialEmail}
                        renderInput={(params) => (
                          <TextField
                            placeholder="Select CMDB user"
                            variant="standard"
                            {...params}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <InputAdornment position="end">
                                  <FaChevronDown className="text-black font-[900] text-end text-[10px]" />{" "}
                                  {/* Custom icon */}
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                        renderOption={(props, option) => (
                          <li
                            {...props}
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "12px",
                              fontWeight: "400",
                            }}
                          >
                            {getOptionLabel(option)}
                          </li>
                        )}
                      />
                    )}

                    <span className="text-red-600 text-[10px]">
                      {errors.officialEmail}
                    </span>
                  </div>
                )}

                {isVesselOperator() && (
                  <div className="col-span-1 animate-modalShow">
                    <label
                      className="block text-gray-700 text-xs"
                      htmlFor="company"
                    >
                      Company
                    </label>

                    <Autocomplete
                      className="mu-input mt-1 p-[9px] border border-gray-300 rounded w-full text-sm"
                      filterOptions={filterOptions}
                      disableClearable={false}
                      onChange={(e, v) => handleCompanyId(e, v)}
                      id="companyId"
                      options={vendors}
                      value={formData.companyId}
                      renderInput={(params) => (
                        <TextField
                          placeholder="Select company"
                          variant="standard"
                          {...params}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <InputAdornment position="end">
                                <FaChevronDown className="text-black font-[900] text-end text-[12px]" />
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "12px",
                            fontWeight: "400",
                          }}
                        >
                          {getOptionLabel(option)}
                        </li>
                      )}
                    />

                    <span className="text-red-600 text-[10px]">
                      {errors.companyId}
                    </span>
                  </div>
                )}

                {isVesselOperator() && (
                  <div className="col-span-1">
                    <label
                      className="block text-gray-700 text-xs"
                      htmlFor="personalEmail"
                    >
                      Organization Email
                    </label>
                    <input
                      type="email"
                      name="personalEmail"
                      value={formData.personalEmail}
                      onChange={handleChange}
                      className="mt-1 p-2 border border-gray-300 rounded w-full text-sm"
                    />
                    <span className="text-red-600 text-[10px]">
                      {errors.personalEmail}
                    </span>
                  </div>
                )}

                {isVesselOperator() && (
                  <div className="col-span-1">
                    <label
                      className="block text-gray-700 text-xs"
                      htmlFor="phone"
                    >
                      Phone
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="mt-1 p-2 border border-gray-300 rounded w-full text-sm"
                    />

                    <span className="text-red-600 text-[10px]">
                      {errors.phone}
                    </span>
                  </div>
                )}

                {isVesselOperator() && (
                  <div className="col-span-1">
                    <label
                      className="block text-gray-700 text-xs"
                      htmlFor="personalPhone"
                    >
                      Alternate Phone
                    </label>
                    <input
                      type="tel"
                      name="personalPhone"
                      value={formData.personalPhone}
                      onChange={handleChange}
                      className="mt-1 p-2 border border-gray-300 rounded w-full text-sm"
                    />

                    <span className="text-red-600 text-[10px]">
                      {errors.personalPhone}
                    </span>
                  </div>
                )}

                {isVesselOperator() && (
                  <div className="col-span-1">
                    <label
                      className="block text-gray-700 text-xs"
                      htmlFor="officialEmail"
                    >
                      {isVesselOperator() ? "Alternate Email" : "Official Email"}
                    </label>

                    {isVesselOperator() ? (
                      <input
                        type="email"
                        name="officialEmail"
                        value={formData.officialEmail}
                        onChange={handleChange}
                        className="mt-1 p-2 border border-gray-300 rounded w-full text-sm  animate-modalShow"
                      />
                    ) : (
                      <Autocomplete
                        className="mu-input mt-1 p-2 border border-gray-300 rounded w-full text-sm animate-modalShow"
                        filterOptions={filterOptions}
                        disableClearable={false}
                        onChange={(e, v) => handleCMDBUser(e, v)}
                        id="cmdbUsers"
                        options={cmdbUsers}
                        value={formData.officialEmail}
                        renderInput={(params) => (
                          <TextField
                            placeholder="Select CMDB user"
                            variant="standard"
                            {...params}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <InputAdornment position="end">
                                  <FaChevronDown className="text-black font-[900] text-end text-[10px]" />{" "}
                                  {/* Custom icon */}
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                        renderOption={(props, option) => (
                          <li
                            {...props}
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "12px",
                              fontWeight: "400",
                            }}
                          >
                            {getOptionLabel(option)}
                          </li>
                        )}
                      />
                    )}

                    <span className="text-red-600 text-[10px]">
                      {errors.officialEmail}
                    </span>
                  </div>
                )}

                <div className="col-span-1">
                  <label
                    className="block text-gray-700 text-xs"
                    htmlFor="firstName"
                  >
                    First Name
                  </label>
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    disabled={!isVesselOperator()}
                    className={`mt-1 p-2 border border-gray-300 rounded w-full text-sm`}
                  />

                  <span className="text-red-600 text-[10px]">
                    {errors.firstName}
                  </span>
                </div>

                <div className="col-span-1">
                  <label
                    className="block text-gray-700 text-xs"
                    htmlFor="lastName"
                  >
                    Last Name
                  </label>
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    disabled={!isVesselOperator()}
                    className={`mt-1 p-2 border border-gray-300 rounded w-full text-sm`}
                  />

                  <span className="text-red-600 text-[10px]">
                    {errors.lastName}
                  </span>
                </div>

                {!isVesselOperator() && (
                  <div className="col-span-2">
                    <label
                      className="block text-gray-700 text-xs"
                      htmlFor="functionalEmail"
                    >
                      Functional Email
                    </label>

                    <Select
                      isMulti
                      options={functionalEmail}
                      value={
                        !!formData.functionalEmail
                          ? JSON.parse(formData.functionalEmail)
                          : []
                      }
                      onChange={handleFunctionalEmailChange}
                      placeholder="Select options..."
                      className="mt-1"
                      components={{
                        Option: CustomOption,
                      }}
                    />

                    <span className="text-red-600 text-[10px]">
                      {errors.functionalEmail}
                    </span>
                  </div>
                )}

                {isVesselOperator() && (
                  <div className="col-span-1">
                    <label
                      className="block text-gray-700 text-xs"
                      htmlFor="Category"
                    >
                      Vessel Category
                    </label>

                    <Select
                      options={vesselCategories}
                      value={
                        !!formData.vesselCategory ? JSON.parse(formData.vesselCategory) : {}
                      }
                      onChange={handleVesselCategoryChange}
                      placeholder="Select options..."
                      className="mt-1"
                      components={{
                        Option: CustomOption,
                      }}
                    />

                    <span className="text-red-600 text-[10px]">
                      {errors.vessel}
                    </span>
                  </div>
                )}

                {isVesselOperator() && (
                  <div className="col-span-1">
                    <label
                      className="block text-gray-700 text-xs"
                      htmlFor="vessel"
                    >
                      Vessel
                    </label>

                    <Select
                      isMulti
                      options={vessels}
                      value={
                        !!formData.vessel ? JSON.parse(formData.vessel) : []
                      }
                      onChange={handleVesselChange}
                      placeholder="Select options..."
                      className="mt-1"
                      components={{
                        Option: CustomOption,
                      }}
                    />

                    <span className="text-red-600 text-[10px]">
                      {errors.vessel}
                    </span>
                  </div>
                )}

                <div className="text-center text-xs col-span-1 sm:col-span-2">
                  <p className="text-red-600">{serverError}</p>
                </div>

                <div className="col-span-1 sm:col-span-2">
                  <button
                    type="submit"
                    className="w-1/2 mx-auto flex font-normal justify-center text-sm bg-red-700 text-white py-2 rounded hover:bg-red-600"
                  >
                    Add user
                  </button>
                </div>
              </div>
            </form>
          </div>
        </section>
      )}

      {/* edit user */}
      {isEditModalOpen && (
        <section className="fixed inset-0 bg-black bg-opacity-50 flex flex-col justify-center items-center">
          <button
            onClick={() => setEditModalOpen(false)}
            className="mt-4 text-red-600 hover:underline p-3 rounded-full bg-white mb-4 text-xl border border-gray-500 shadow animate-modalShow"
          >
            <LuX />
          </button>

          <div className="bg-white rounded shadow-md w-full max-w-xl animate-modalShow">
            <form onSubmit={handleEditSubmit} autoComplete="off">
              <h2 className="text-md font-medium mb-4 flex-col border-b p-3 px-6 bg-gray-100 rounded-t">
                Manage user
              </h2>

              <div className="grid grid-cols-1 gap-3 gap-y-3 sm:grid-cols-2 w-full  px-6 pb-16 max-h-[90vh] overflow-y-scroll mb-4">
                <div className="col-span-1">
                  <label className="block text-gray-700 text-xs" htmlFor="role">
                    Select Role
                  </label>

                  <Select
                    isMulti
                    options={roles}
                    value={!!formData.role ? JSON.parse(formData.role) : []}
                    onChange={handleRoleChange}
                    placeholder="Select options..."
                    className="mt-1"
                    components={{
                      Option: CustomOption,
                    }}
                  />

                  <span className="text-red-600 text-[10px]">
                    {errors.role}
                  </span>
                </div>

                {!isVesselOperator() && (
                  <div className="col-span-1">
                    <label
                      className="block text-gray-700 text-xs"
                      htmlFor="officialEmail"
                    >
                      {isVesselOperator() ? "Personal Email" : "Official Email"}
                    </label>

                    {isVesselOperator() ? (
                      <input
                        type="email"
                        name="officialEmail"
                        value={formData.officialEmail}
                        onChange={handleChange}
                        className="mt-1 p-2 border border-gray-300 rounded w-full text-sm  animate-modalShow"
                      />
                    ) : (
                      <Autocomplete
                        className="mu-input mt-1 p-2 border border-gray-300 rounded w-full text-sm animate-modalShow"
                        filterOptions={filterOptions}
                        disableClearable={false}
                        onChange={(e, v) => handleCMDBUser(e, v)}
                        id="cmdbUsers"
                        options={cmdbUsers}
                        value={formData.officialEmail}
                        renderInput={(params) => (
                          <TextField
                            placeholder="Select CMDB user"
                            variant="standard"
                            {...params}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <InputAdornment position="end">
                                  <FaChevronDown className="text-black font-[900] text-end text-[10px]" />{" "}
                                  {/* Custom icon */}
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                        renderOption={(props, option) => (
                          <li
                            {...props}
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "12px",
                              fontWeight: "400",
                            }}
                          >
                            {getOptionLabel(option)}
                          </li>
                        )}
                      />
                    )}

                    <span className="text-red-600 text-[10px]">
                      {errors.officialEmail}
                    </span>
                  </div>
                )}

                {isVesselOperator() && (
                  <div className="col-span-1 animate-modalShow">
                    <label
                      className="block text-gray-700 text-xs"
                      htmlFor="company"
                    >
                      Company
                    </label>

                    <Autocomplete
                      className="mu-input mt-1 p-[9px] border border-gray-300 rounded w-full text-sm"
                      filterOptions={filterOptions}
                      disableClearable={false}
                      onChange={(e, v) => handleCompanyId(e, v)}
                      id="companyId"
                      options={vendors}
                      value={formData.companyId}
                      renderInput={(params) => (
                        <TextField
                          placeholder="Select company"
                          variant="standard"
                          {...params}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <InputAdornment position="end">
                                <FaChevronDown className="text-black font-[900] text-end text-[12px]" />
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "12px",
                            fontWeight: "400",
                          }}
                        >
                          {getOptionLabel(option)}
                        </li>
                      )}
                    />

                    <span className="text-red-600 text-[10px]">
                      {errors.companyId}
                    </span>
                  </div>
                )}

                {isVesselOperator() && (
                  <div className="col-span-1">
                    <label
                      className="block text-gray-700 text-xs"
                      htmlFor="personalEmail"
                    >
                      Organization Email
                    </label>
                    <input
                      type="email"
                      name="personalEmail"
                      value={formData.personalEmail}
                      onChange={handleChange}
                      className="mt-1 p-2 border border-gray-300 rounded w-full text-sm"
                      
                    />
                    <span className="text-red-600 text-[10px]">
                      {errors.personalEmail}
                    </span>
                  </div>
                )}

                {isVesselOperator() && (
                  <div className="col-span-1">
                    <label
                      className="block text-gray-700 text-xs"
                      htmlFor="phone"
                    >
                      Phone
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="mt-1 p-2 border border-gray-300 rounded w-full text-sm"
                      disabled
                    />

                    <span className="text-red-600 text-[10px]">
                      {errors.phone}
                    </span>
                  </div>
                )}

                {isVesselOperator() && (
                  <div className="col-span-1">
                    <label
                      className="block text-gray-700 text-xs"
                      htmlFor="personalPhone"
                    >
                      Alternate Phone
                    </label>
                    <input
                      type="tel"
                      name="personalPhone"
                      value={formData.personalPhone}
                      onChange={handleChange}
                      className="mt-1 p-2 border border-gray-300 rounded w-full text-sm"
                    />

                    <span className="text-red-600 text-[10px]">
                      {errors.personalPhone}
                    </span>
                  </div>
                )}

                {isVesselOperator() && (
                  <div className="col-span-1">
                    <label
                      className="block text-gray-700 text-xs"
                      htmlFor="officialEmail"
                    >
                      {isVesselOperator() ? "Alternate Email" : "Official Email"}
                    </label>

                    {isVesselOperator() ? (
                      <input
                        type="email"
                        name="officialEmail"
                        value={formData.officialEmail}
                        onChange={handleChange}
                        className="mt-1 p-2 border border-gray-300 rounded w-full text-sm  animate-modalShow"
                      />
                    ) : (
                      <Autocomplete
                        className="mu-input mt-1 p-2 border border-gray-300 rounded w-full text-sm animate-modalShow"
                        filterOptions={filterOptions}
                        disableClearable={false}
                        onChange={(e, v) => handleCMDBUser(e, v)}
                        id="cmdbUsers"
                        options={cmdbUsers}
                        value={formData.officialEmail}
                        renderInput={(params) => (
                          <TextField
                            placeholder="Select CMDB user"
                            variant="standard"
                            {...params}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <InputAdornment position="end">
                                  <FaChevronDown className="text-black font-[900] text-end text-[10px]" />{" "}
                                  {/* Custom icon */}
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                        renderOption={(props, option) => (
                          <li
                            {...props}
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "12px",
                              fontWeight: "400",
                            }}
                          >
                            {getOptionLabel(option)}
                          </li>
                        )}
                      />
                    )}

                    <span className="text-red-600 text-[10px]">
                      {errors.officialEmail}
                    </span>
                  </div>
                )}

                <div className="col-span-1">
                  <label
                    className="block text-gray-700 text-xs"
                    htmlFor="firstName"
                  >
                    First Name
                  </label>
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    disabled={!isVesselOperator()}
                    className={`mt-1 p-2 border border-gray-300 rounded w-full text-sm`}
                  />

                  <span className="text-red-600 text-[10px]">
                    {errors.firstName}
                  </span>
                </div>

                <div className="col-span-1">
                  <label
                    className="block text-gray-700 text-xs"
                    htmlFor="lastName"
                  >
                    Last Name
                  </label>
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    disabled={!isVesselOperator()}
                    className={`mt-1 p-2 border border-gray-300 rounded w-full text-sm`}
                  />

                  <span className="text-red-600 text-[10px]">
                    {errors.lastName}
                  </span>
                </div>

                {!isVesselOperator() && (
                  <div className="col-span-2">
                    <label
                      className="block text-gray-700 text-xs"
                      htmlFor="functionalEmail"
                    >
                      Functional Email
                    </label>

                    <Select
                      isMulti
                      options={functionalEmail}
                      value={
                        !!formData.functionalEmail
                          ? JSON.parse(formData.functionalEmail)
                          : []
                      }
                      onChange={handleFunctionalEmailChange}
                      placeholder="Select options..."
                      className="mt-1"
                      components={{
                        Option: CustomOption,
                      }}
                    />

                    <span className="text-red-600 text-[10px]">
                      {errors.functionalEmail}
                    </span>
                  </div>
                )}

                {isVesselOperator() && (
                  <div className="col-span-1">
                    <label
                      className="block text-gray-700 text-xs"
                      htmlFor="Category"
                    >
                      Vessel Category
                    </label>

                    <Select
                      options={vesselCategories}
                      value={
                        !!formData.vesselCategory ? formData.vesselCategory : {}
                      }
                      onChange={handleVesselCategoryChange}
                      placeholder="Select options..."
                      className="mt-1"
                      components={{
                        Option: CustomOption,
                      }}
                    />

                    <span className="text-red-600 text-[10px]">
                      {errors.vessel}
                    </span>
                  </div>
                )}

                {isVesselOperator() && (
                  <div className="col-span-1">
                    <label
                      className="block text-gray-700 text-xs"
                      htmlFor="vessel"
                    >
                      Vessel
                    </label>

                    <Select
                      isMulti
                      options={vessels}
                      value={
                        !!formData.vessel ? JSON.parse(formData.vessel) : []
                      }
                      onChange={handleVesselChange}
                      placeholder="Select options..."
                      className="mt-1"
                      components={{
                        Option: CustomOption,
                      }}
                    />

                    <span className="text-red-600 text-[10px]">
                      {errors.vessel}
                    </span>
                  </div>
                )}

                <div className="text-center text-xs col-span-1 sm:col-span-2">
                  <p className="text-red-600">{serverError}</p>
                </div>

                <div className="col-span-1 sm:col-span-2">
                  <button
                    type="submit"
                    className="w-1/2 mx-auto flex font-normal justify-center text-sm bg-red-700 text-white py-2 rounded hover:bg-red-600"
                  >
                    Update user
                  </button>
                </div>
              </div>
            </form>
          </div>
        </section>
      )}

      <ToastContainer position="bottom-left" hideProgressBar />
      <Preloader loading={loading} />
    </>
  );
};

export default VendorManagement;
